import { render } from "./ApproveAcceptanceDetail.vue?vue&type=template&id=7f6ddb21&scoped=true"
import script from "./ApproveAcceptanceDetail.vue?vue&type=script&lang=ts"
export * from "./ApproveAcceptanceDetail.vue?vue&type=script&lang=ts"

import "./ApproveAcceptanceDetail.vue?vue&type=style&index=0&id=7f6ddb21&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7f6ddb21"

export default script